import React from 'react';
import { FooterButtonServiceAcceptance } from '../styles';
import Button from '../../../components/Button';
import { ButtonProps } from './button-continue';

const ButtonServiceAcceptance: React.FC<ButtonProps> = ({
  onClick,
  theme,
  text,
}) => {
  return (
    <>
      <FooterButtonServiceAcceptance>
        <p>Ao clicar em continuar você aceita os termos contratados acima.</p>
        <Button data-cy="continue-button" onClick={onClick} theme={theme}>
          {text}
        </Button>
      </FooterButtonServiceAcceptance>
    </>
  );
};

export default ButtonServiceAcceptance;
